import Modal from './Modal';
import ModalActions from './ModalActions';

export default Modal;
export { ModalActions };